import { COLORS } from '@btime/constants'
import { capitalizeAll } from '@btime/helpers'
import { compose, join, paths } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useEditServiceOrdersStatusAction } from '../../../utils/actions/serviceOrders/actions'
import { useIsPermalinkPage } from '../../../utils/session/permalinkToken'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import { useServiceOrder } from './_load/ServiceOrderLoader'
import DropdownLink from '../../../components/navigation/DropdownLink'
import FlexGrid from '../../../components/structure/FlexGrid'
import IconText from '../../../components/presentation/IconText'
import Link from '../../../components/actions/Link'
import PageHeaderPanel from '../../../components/presentation/PageHeaderPanel'
import { useServiceOrderPermissions } from '../../../utils/permissions/serviceOrders/serviceOrderPermissions'
import { useLoggedUser } from '@btime/react-session'

const ResumePageHeader = () => {
  const user = useLoggedUser()
  const isLoggedIn = !!user?.id
  const { t } = useTranslation()
  const navigate = useNavigation()
  const serviceOrder = useServiceOrder()
  const changeStatus = useEditServiceOrdersStatusAction([serviceOrder.id])
  const isPublic = useIsPermalinkPage()
  const { canEditFinishedServiceOrders, canEdit } = useServiceOrderPermissions()

  const finishedStatuses = ['refused', 'unproductive', 'completed', 'pending', 'canceled', 'approved', 'disapproved']
  const isFinished = finishedStatuses.includes(serviceOrder?.status?.name)
  const canEditServiceOrder = isLoggedIn && canEdit && (!isFinished || canEditFinishedServiceOrders)

  const titlePaths = serviceOrder?.checklist
    ? paths([['yearlyId'], ['checklist', 'name']])
    : paths([['yearlyId'], ['name']])

  const title = compose(capitalizeAll, join(' - '), titlePaths)(serviceOrder)

  const editPath = `/service-orders/${serviceOrder.id}/execution?ignoreValidation=true`

  return (
    <PageHeaderPanel
      leftIcon={!isPublic && 'BsArrowLeftShort'}
      leftAction={() => navigate('/service-orders')}
      title={title}
      mediumPadding
      noContainer
      side={
        <FlexGrid justify="flex-end" gutter={0.7}>
          {canEditServiceOrder && (
            <Link block onClick={() => navigate(editPath)} to={editPath}>
              <IconText
                iconSize="1.4rem"
                weight="700"
                iconName="BsPencilSquare"
                color={COLORS.white}
                label={t('edit')}
              />
            </Link>
          )}

          {!isPublic && changeStatus.hasPermission && (
            <DropdownLink
              options={[
                {
                  label: t('approve'),
                  icon: 'BsFileEarmarkCheck',
                  color: COLORS.green,
                  onClick: () => changeStatus.click('approved')
                },
                {
                  label: t('disapprove'),
                  icon: 'BsFileEarmarkMinus',
                  color: COLORS.red,
                  onClick: () => changeStatus.click('disapproved')
                }
              ]}
              fromRight
              actionContent={
                <IconText
                  iconSize="1.4rem"
                  weight="700"
                  iconName="BsThreeDotsVertical"
                  color={COLORS.white}
                  label={t('approval')}
                  noWrap
                />
              }
            />
          )}
        </FlexGrid>
      }
    />
  )
}

export default ResumePageHeader
